import React, { useEffect } from "react";
import { Link } from "react-router-dom";
// import { getNovedades } from "../services/api";
import { blogData } from "../data/data";
//zustand--------
import useStore from "../store/useStore";

import ContactUs from "../components/contactUs";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import Navbar from "../components/navbar";

export default function Blog() {
  //   const [blogs, setBlogs] = useState([]);
  const { novedades, fetchNovedades } = useStore();

  useEffect(() => {
    // const fetchBlogs = async () => {
    //   try {
    //     const data = await getNovedades();
    //     setBlogs(data.data || []);
    //   } catch (error) {
    //     console.error("Error al obtener las novedades:", error);
    //   }
    // };

    // fetchBlogs();
    fetchNovedades();
  }, [fetchNovedades]);

  const renderBlogCards = () => {
    return novedades.length > 0 ? (
      novedades.map((item, index) => {
        const { titulo = "Sin título", contenido = [], imagen } = item || {};
        const descripcionCompleta =
          contenido
            .map((c) => c.children?.map((child) => child.text).join(" "))
            .join(" ") || "Sin descripción";

        const imagenUrl = imagen?.[0]?.formats?.thumbnail?.url
          ? `${process.env.REACT_APP_STRAPI_URL}${imagen[0].formats.thumbnail.url}`
          : "https://dummyimage.com/400x400/cccccc/000000&text=No+Image";

        return (
          <div className="group" key={index}>
            <div className="relative overflow-hidden rounded-xl shadow-md dark:shadow-gray-700">
              <img
                src={imagenUrl}
                className="w-full h-[250px] object-cover"
                alt={titulo}
              />
              <div className="absolute inset-0 bg-gradient-to-b to-slate-900 from-transparent opacity-0 group-hover:opacity-100 duration-500"></div>
              <div className="absolute start-4 bottom-4 opacity-0 group-hover:opacity-100 flex items-center duration-500">
                <img src={imagenUrl} className="h-9 w-9 rounded-xl" alt="" />
                <div className="ms-2">
                  <Link
                    to=""
                    className="text-white hover:text-orange-500 text-[15px]"
                  >
                    {titulo}
                  </Link>
                  <p className="text-white/70 text-sm">5 Min Read</p>
                </div>
              </div>
            </div>
            <div className="p-4">
              <Link
                to={`/blog-detail/${item.id}`}
                className="title text-lg font-medium hover:text-orange-500 duration-500"
              >
                {titulo}
              </Link>
              <p className="text-slate-400 dark:text-white/60 mt-3">
                {descripcionCompleta}
              </p>
              <div className="mt-3">
                <Link
                  to={`/blog-detail/${item.id}`}
                  className="hover:text-orange-500"
                >
                  Read More <i className="mdi mdi-arrow-right align-middle"></i>
                </Link>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <p className="text-center text-slate-400 dark:text-white/60">
        No hay novedades disponibles.
      </p>
    );
  };

  return (
    <>
      <Navbar />
      <section className="relative table w-full py-32 lg:py-40 bg-[url('../../assets/images/portfolio/bg-inner.jpg')] bg-no-repeat bg-top bg-cover">
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/80 to-black"></div>
        <div className="container relative">
          <div className="grid grid-cols-1 pb-8 text-center mt-10">
            <h3 className="text-3xl leading-normal font-medium text-white">
              Blogs & News
            </h3>
          </div>
        </div>
        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="tracking-[0.5px] mb-0 inline-block">
            <li className="inline-block capitalize text-[14px] duration-500 ease-in-out text-white/50 hover:text-white">
              <Link to="/">Muvico</Link>
            </li>
            <li className="inline-block text-[18px] text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180">
              <i className="mdi mdi-chevron-right align-middle"></i>
            </li>
            <li
              className="inline-block capitalize text-[14px] duration-500 ease-in-out text-white"
              aria-current="page"
            >
              Blogs
            </li>
          </ul>
        </div>
      </section>

      <div className="relative">
        <div className="shape absolute sm:-bottom-px -bottom-[2px] start-0 end-0 overflow-hidden z-1 text-white dark:text-slate-900">
          <svg
            className="w-full h-auto scale-[2.0] origin-top"
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>

      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
            {blogData.map((item, index) => (
              <div className="group" key={index}>
                <div className="relative overflow-hidden rounded-xl shadow-md dark:shadow-gray-700">
                  <img src={item.image} className="" alt="" />
                  <div className="absolute inset-0 bg-gradient-to-b to-slate-900 from-transparent opacity-0 group-hover:opacity-100 duration-500"></div>
                  <div className="absolute start-4 bottom-4 opacity-0 group-hover:opacity-100 flex items-center duration-500">
                    <img
                      src={item.image1}
                      className="h-9 w-9 rounded-xl"
                      alt=""
                    />
                    <div className="ms-2">
                      <Link
                        to=""
                        className="text-white hover:text-orange-500 text-[15px]"
                      >
                        {item.athor}
                      </Link>
                      <p className="text-white/70 text-sm">5 Min Read</p>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <Link
                    to={`/blog-detail/${item.id}`}
                    className="title text-lg font-medium hover:text-orange-500 duration-500"
                  >
                    {item.title}
                  </Link>
                  <p className="text-slate-400 dark:text-white/60 mt-3">
                    {item.desc}
                  </p>
                  <div className="mt-3">
                    <Link
                      to={`/blog-detail/${item.id}`}
                      className="hover:text-orange-500"
                    >
                      Read More{" "}
                      <i className="mdi mdi-arrow-right align-middle"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 mt-10">
            {renderBlogCards()}
          </div>
        </div>
        <ContactUs />
      </section>

      <Footer />
      <Switcher />
    </>
  );
}
